// Utility function to calculate vague "last seen" time
export const getLastSeenText = (lastActiveAt, isOnline = false) => {
  // If user is online, show "Online"
  if (isOnline) {
    return "Online";
  }

  // If no lastActiveAt data, show generic offline
  if (!lastActiveAt) {
    return "Last seen a while ago";
  }

  const now = new Date();
  const lastActive = new Date(lastActiveAt);
  const diffMs = now - lastActive;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // Less than 1 minute - show as "just now"
  if (diffMinutes < 1) {
    return "Last seen just now";
  }

  // 1-30 minutes - show specific minutes
  if (diffMinutes <= 30) {
    return `Last seen ${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`;
  }

  // 31-59 minutes - show "under an hour"
  if (diffMinutes < 60) {
    return "Last seen under an hour ago";
  }

  // 1-6 hours - show specific hours
  if (diffHours <= 6) {
    return `Last seen ${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  }

  // Same day but more than 6 hours
  const isToday = lastActive.toDateString() === now.toDateString();
  if (isToday) {
    return "Last seen earlier today";
  }

  // Yesterday
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday = lastActive.toDateString() === yesterday.toDateString();
  if (isYesterday) {
    return "Last seen yesterday";
  }

  // This week (within 7 days)
  if (diffDays <= 7) {
    return "Last seen this week";
  }

  // More than a week ago
  return "Last seen over a week ago";
};